import React from "react";
import ZestComponent from "./ZestComponent";

export interface EmptyStateProps {
  emptyMessage?: string;
}

// role="status" so that swapping a populated list out for this bar — after a
// filter change or a fetch — is announced, rather than the content silently
// disappearing for screen reader users.
const EmptyState = ({ emptyMessage = "" }: EmptyStateProps): JSX.Element => (
  <ZestComponent
    name="empty-state"
    role="status"
    className="h-8 px-4 bg-lighter rounded text-secondary flex items-center font-semibold"
  >
    {emptyMessage}
  </ZestComponent>
);

export default EmptyState;
